// extracted by css-extract-rspack-plugin
export default {"root":"FtrKYSLnA10cy2g9","content":"Nydvt5Q4ixQpWRnG","actions":"QU6UaIyY0c46MPB1"};